import { Message, Stack, Text } from "basis";
import React from "react";
import { ApiData } from "../AddressForm/types";

interface Props {
  mailing: ApiData["mailing"];
}

export const MailingResult = ({ mailing }: Props) => (
  <Stack gap="4" testId="mailing-address">
    <Text as="h3" textStyle="heading5" color="primary.blue.t100">
      Mailing address
    </Text>
    {mailing.status === "success" ? (
      <Text>Same as residential address</Text>
    ) : (
      <Message severity="blocking" bg="secondary.pink.t30">
        We were unable to update your mailing address at this time. Please try
        again from the manage personal details page.
      </Message>
    )}
  </Stack>
);
